import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ShieldCheck, Mail, KeyRound, Loader2 } from "lucide-react";

// Hidden backup admin login (email/password). Reachable only via /admin-login.
export default function AdminLogin() {
  const { setUser } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      toast.success("Connecté (admin)");
      window.location.href = "/";
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Échec");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 dot-grid">
      <div className="w-full max-w-md glass rounded-2xl border border-border p-7 fade-up">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-md bg-primary/15 border border-primary/40 flex items-center justify-center glow-primary">
            <ShieldCheck className="w-6 h-6 text-primary" />
          </div>
          <div>
            <div className="font-head font-bold text-xl tracking-wide text-glow">KSOS HUB</div>
            <div className="text-[10px] text-muted-foreground tracking-[0.2em] uppercase">Accès administrateur</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <input data-testid="admin-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Email admin" className="cfg-input pl-9" />
          </div>
          <div className="relative">
            <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <input data-testid="admin-password-input" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="Mot de passe" className="cfg-input pl-9" />
          </div>
          <button data-testid="admin-submit" type="submit" disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-primary py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/85 transition-colors disabled:opacity-50">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Se connecter
          </button>
        </form>

        <a href="/" data-testid="admin-back" className="block text-center text-xs text-muted-foreground hover:text-foreground mt-4">
          ← Connexion joueur (Discord)
        </a>
      </div>
    </div>
  );
}
